import { combineReducers } from '@reduxjs/toolkit';
import { apis } from '~/store/apis/endpoints/apis';
import additionalSignerSliceReducer from '../slices/additionalSigner.slice';
import cardApplicationSliceReducer from '../slices/cardApplication.slice';
import cardOfferSliceReducer from '../slices/cardOffer.slice';
import globalErrorSliceReducer from '../slices/globalError.slice';
import globalModalSliceReducer from '../slices/globalModal.slice';
import helpPopupSliceReducer from '../slices/helpPopup.slice';
import intlSliceReducer from '../slices/intl.slice';
import loanApplicationSliceReducer from '../slices/loanApplication.slice';
import loanOfferSliceReducer from '../slices/loanOffer.slice';
import matchedMediaSliceReducer from '../slices/matchedMedia.slice';
import updateApplicationSliceReducer from '../slices/updateApplication/updateApplication.slice';
import eskatReducer from './eskatReducer';
import klarnaKosmaReducer from './klarnaKosmaReducer';

const rootReducer = combineReducers({
  ...apis,
  klarnaKosma: klarnaKosmaReducer,
  eskat: eskatReducer,
  updateApplication: updateApplicationSliceReducer,
  loanOffer: loanOfferSliceReducer,
  globalModals: globalModalSliceReducer,
  loanApplication: loanApplicationSliceReducer,
  cardApplication: cardApplicationSliceReducer,
  globalError: globalErrorSliceReducer,
  helpPopup: helpPopupSliceReducer,
  matchedMedia: matchedMediaSliceReducer,
  intl: intlSliceReducer,
  cardOffer: cardOfferSliceReducer,
  additionalSigner: additionalSignerSliceReducer,
});

export default rootReducer;
